import { BinaryFilter, Filter } from '@cubejs-client/core';

import { INSIGHT_CUBE_NAME } from '@/api/hcp/interaction/types';
import { coerceInsightAssignment, InsightAssignment } from '@/pages/Insights/types/store';
import { FilterConfigStatic } from '@/types/filter';

const IS_HCP_INSIGHT = `${INSIGHT_CUBE_NAME}.is_hcp_insight`;
const IS_HCO_INSIGHT = `${INSIGHT_CUBE_NAME}.is_hco_insight`;

const flagEquals = (member: string, value: 'true' | 'false'): BinaryFilter => ({
  member,
  operator: 'equals',
  values: [value],
});

/**
 * Maps the single-select "Insight assignment" value to the equivalent `insight` cube filter.
 * "assigned to HCP" matches every insight with an HCP link (including insights also linked to an
 * HCO), and likewise for "assigned to HCO"; "unassigned" matches insights with neither link.
 * `''` is a no-op.
 */
export const buildInsightAssignmentFilter = (value: InsightAssignment): Filter | undefined => {
  switch (value) {
    case 'hcp':
      return flagEquals(IS_HCP_INSIGHT, 'true');
    case 'hco':
      return flagEquals(IS_HCO_INSIGHT, 'true');
    case 'unassigned':
      return { and: [flagEquals(IS_HCP_INSIGHT, 'false'), flagEquals(IS_HCO_INSIGHT, 'false')] };
    default:
      return undefined;
  }
};

const insightAssignmentFilter: FilterConfigStatic = {
  label: 'main.insights.filters.labels.insightAssignment',
  placeholder: 'main.insights.filters.labels.insightAssignment',
  type: 'dropdown',
  defaultValue: '',
  clearable: true,
  useFloatingLabel: true,
  options: [
    { value: 'hcp', label: 'main.insights.filters.insightAssignment.options.hcp' },
    { value: 'hco', label: 'main.insights.filters.insightAssignment.options.hco' },
    { value: 'unassigned', label: 'main.insights.filters.insightAssignment.options.unassigned' },
  ],
  applyFilter: value => buildInsightAssignmentFilter(coerceInsightAssignment(value)),
};

export default insightAssignmentFilter;
